import { Collapsible as UiCollapsible } from "@ark-ui/react/collapsible"
import { styled } from "styled-system/jsx"

const Root = styled(UiCollapsible.Root)
const Trigger = styled(UiCollapsible.Trigger)
const Content = styled(UiCollapsible.Content, {
  base: {
    overflow: "hidden",
    _open: {
      animationName: "[expand-height, fade-in]",
      animationDuration: "normal",
    },
    _closed: {
      animationName: "[collapse-height, fade-out]",
      animationDuration: "normal",
    },
  },
})

export const Collapsible = {
  Root,
  Trigger,
  Content,
} as const
